export default __webpack_public_path__ + "static/media/bathrobes.f05fd295.svg";